<template>
    <section v-if="hasPermissions(['Report Read', 'Report Write'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb" />
        <h1 class="view__title title--1" v-html="title_page" />

        <div class="view__description">
            <p class="view__description__text">
                This is the data view for your report. Here, you can filter and customize the data you want to include in
                your report. Start by reviewing the available filters and select the criteria you want to apply.
            </p>
        </div>

        <div class="row bar__container" style="margin-top:10px; margin-bottom:10px;">
            <div class="col-md-auto flex-xl-grow-1">
                <div class="modal__buttons text-center text-md-left text-lg-right" style="margin-top:0px;">
                    <div class="formdynamic__item__field d-inline-block text-lg-left mr-3" style="width: 17rem">
                        <label class="modal-label" v-html="`Report's name`"/>
                        <input type="text" v-model="report_name" style="max-width: 19rem"/>
                    </div>
                    <button v-if="hasPermissions(['Report Write'])" class="modal__buttons__item w-auto ml-1 ml-md-2 px-3"
                        v-html="`Save`" style="margin-right:0px;" @click="save()" />
                    <div v-if="hasPermissions(['Report Write'])"
                        class="btn-group modal__buttons__item w-auto mr-md-auto ml-sm-2 px-3 ml-md-2"
                        style="margin-top:-2px;">
                        <button type="button"
                            style="border-top-right-radius: 0px; border-bottom-right-radius: 0px; padding-right:15px;"
                            v-html="'Export to'" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />
                        <button type="button" class="dropdown-toggle dropdown-toggle-split ml-0" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false"
                            style="border-top-left-radius: 0px; border-bottom-left-radius: 0px; padding-right:0px;">
                            <span class="sr-only">Toggle Dropdown</span>
                        </button>
                        <div class="dropdown-menu" :style="'font-size: 14px; padding:0; margin-top: 0px;'">
                            <a class="dropdown-item" href="#" @click="running_submit('xlsx')" v-html="'xlsx'" />
                            <a class="dropdown-item" href="#" @click="running_submit('csv')" v-html="'csv'" />
                            <a class="dropdown-item" href="#" @click="running_submit('portrait')" v-html="'PDF portrait'" />
                            <a class="dropdown-item" href="#" @click="running_submit('landscape')" v-html="'PDF landscape'" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <AdvancedSearch
            class="mt-5"
            :show_sq_ft="false"
            :for_reports="true"
            :db_totals="db_totals"
            :checkeable="true"
            :rest_api="rest_api"
            :rest_api_pagination="rest_api"
            :table_headers="table_headers"
            :form_data="form_data"
            :form_format="form_format"
            :module_name="module_name"
            :selectable_columns="false"
            @passInitialData="getInitialData($event)"
            @orderRequest="orderRequest($event)"
            ref="advanced_search"
        />

        <WaitingModal />

    </section>

    <section v-else>
        <Breadcrumb :breadcrumb="breadcrumb" />
        <h1 class="view__title title--1">
            you do not have permission for this section. contact your system administrator
        </h1>
    </section>
</template>
  
<script>
import axios from 'axios';
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import AdvancedSearch  from    '@/components/ReportsComponent/NewReports/AdvancedSearch/AdvancedSearch'
import WaitingModal from '@/components/WaitingModal'
import Resources from './resources'
import FormResources from './form_resources'
import FormFormatResources from './form_format_resources'
import LocalMethods from './local_methods'
import 'vuetify/dist/vuetify.min.css'

import { Notyf } from 'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name: 'ReportView',

    props: [

    ],

    components: {
        Breadcrumb,
        WaitingModal,
        AdvancedSearch
    },

    mixins: [
        LocalMethods,
    ],

    data() {
        return {
            notyf,
            axios,
            user: this.get_user(),
            title_page: 'Report View',
            rest_api: `new_reports/generate`,
            rest_api_reports: 'reports',
            table_headers: [],
            form_data: {},
            form_format: [],
            breadcrumb: Resources.breadcrumb,
            array_options: {},
            report_data: [],
            report_name: '',
            report_format_name: '',
            module_name: '',
            db_totals: [],
            id: null
        }
    },

    methods: {


        fill_data(data)
        {
            /* 
                Report Data
            */
            const report = data.report

            this.module_name = report.module_name
            this.report_name = `${report.name}`

            const report_format_name = this.module_name.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
            this.report_format_name = report_format_name

            this.breadcrumb.push({
                name: `${report_format_name} Report`,
                href: "/reports",
                arrow: "",
            })

            /* 
                Report Totals
            */

            this.db_totals = report.total_columns

            /* 
                Report Headers
            */

            let local_headers = Resources[`${this.module_name}_table_headers`]
            let db_headers = report.field_columns

            let headers = []

            db_headers.forEach((obj2) => {
                const obj1 = local_headers.find((item) => item.model_name === obj2.model_name)

                if (obj1) 
                {
                    headers.push(obj2)
                } 
            });

            local_headers.forEach((obj1) => 
            {
                const obj2 = db_headers.find((item) => item.model_name === obj1.model_name)

                if (!obj2) 
                {
                    headers.push({ model_name: obj1.model_name, show: false })
                }
            });

            this.table_headers = headers

            this.$refs.advanced_search.refreshHeaders()

            /* 
                Report Forms
            */

            let local_form_data = FormResources[`${this.module_name}_form_data`]
            let local_form_data_keys = Object.keys(local_form_data)

            let db_form_data = report.filter_columns

            local_form_data_keys.filter( local_field => 
            {
                if(db_form_data[local_field])
                {
                    local_form_data[local_field] = db_form_data[local_field]
                }
                
            })

            local_form_data['report_name']  = report.module_name
            local_form_data['sort_column']  = report.order_field
            local_form_data['sort_type']    = report.order_by

            this.form_data = local_form_data

            /* 
                Report Format
            */

            this.form_format = FormFormatResources[`${this.module_name}_form_format`]

        },

    },

    async mounted() 
    {
        if (this.hasPermissions(['Report Read', 'Report Write'])) 
        {
            this.module_name = this.$route.params.report_name

            if(!isNaN(this.module_name))
            {
                await this.api_request(`${this.rest_api_reports}/${this.module_name}`)
                this.id = this.$route.params.report_name
            }
            else
            {
                this.rest_api = `${this.rest_api}?report_name=${this.module_name}`

                const dateTime = this.getDateTimeFormat('', 'MM/DD/YYYY HH:mm')
                const report_format_name = this.module_name.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')
                this.report_format_name = report_format_name

                this.report_name = `${report_format_name} Data Report - ${dateTime}`

                this.breadcrumb.push({
                    name: `${report_format_name} Report`,
                    href: "/reports",
                    arrow: "",
                })

                this.table_headers = Resources[`${this.module_name}_table_headers`];
                this.form_data = FormResources[`${this.module_name}_form_data`];
                this.form_format = FormFormatResources[`${this.module_name}_form_format`];

                this.$refs.advanced_search.refreshHeaders()
            }

        }
        else 
        {
            window.location.href = '/'
        }
    },

}
</script>
  
<style scoped>
</style>